import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { CheckBoxInput } from 'components/CheckBox/style';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputLabel } from 'components/InputIcon/styles' 
import { MainContainer, SuggestLabel, LabelContainer } from 'components/SearchableDropdown/styles';
import { InputContainer } from 'components/InputIcon/styles';

export const GeneralContainer = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    margin: 0px 0px 50px 0px;
    
    ${MainContainer} {
        height: unset;
    }

    ${ListItemContent} {
        padding: 0;
    }
    
`

export const Title = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;
    font-family: Rubik;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;    
    text-align: left;
    color: #525252;    
    margin-bottom: ${SIZE.FIVE}px;
    position: relative;
`

export const IconContainer = styled.div`    
    position: relative;
    margin-left: ${SIZE.HALF}px;
    min-width:35px;
`

export const InputTextarea = styled.textarea`
    display: flex;
    width: calc(100% - ${SIZE.TWO}px);
    padding: ${SIZE.ONE}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    outline: none;
    border:none;
    overflow: auto;
    min-height: ${SIZE.FIFTEEN}px; 
    color: #3D3D3D;
    resize:none;
`
export const BodyContainer = styled.div`
    padding: 30px 35px 30px 35px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
`

export const ViewLabel = styled.span`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #000000;
    overflow-wrap: break-word;
    word-break: break-all;
`

export const ViewLabelUrl = styled.span`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #4da0ff;
    text-decoration: underline;
    inline-size: 300px;    
    word-break: break-all;
`

export const UrlSectionContainer = styled.div`
    display: flex;
    position: relative;
    flex-flow: column;
    padding: ${SIZE.ONE}px ${SIZE.ONE}px ${SIZE.ONE}px 0;
`

export const Input = styled.input`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #343434;
    outline: none;
    border: none;
    padding: ${SIZE.ONE}px;
    flex:1;
`

export const DisclaimerLabel = styled(Label)`
    display:flex;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-family: Rubik;
    font-size: 16px;
    text-align: left;
    padding: ${SIZE.HALF}px 0 ;
    color: rgba(112, 112, 112, 0.5);
`

export const DateFieldWrapper = styled.div`
    display:flex;
    padding: ${SIZE.ONE}px ${SIZE.ONE}px ${SIZE.ONE}px 0;
`

export const PhoneMainContainer = styled.div`
    display:flex;
    padding: ${SIZE.HALF}px ${SIZE.HALF}px ${SIZE.HALF}px 0;
    flex-flow:column;
`

export const PhoneChecboxContainer = styled.div`
    display:flex;
    padding: ${SIZE.ONE}px 0 0 0;
    &${CheckBoxInput}{
        border: #ff7319;
    }
`

export const PhoneCheckboxLabel = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    margin-left: ${SIZE.ONE}px;
    text-align: left;
    color: #707070;
`

export const FormatsAbsoluteContainer = styled.div`
    position: absolute;
    top: ${SIZE.THREE}px;
    left: ${SIZE.HALF}px;
    max-width: 80px;
    word-wrap: break-word;
    z-index: 100;
    display: none;
    text-align: left;
    ${IconContainer}:hover & {
        display: flex;
        max-width: 80px;
    }
    
`;

export const FormatsContainer = styled.div`
    margin: 1.7px 0 0;
    padding: 9px 12px 3px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const FormatLabel = styled.div`
    padding: 0px 0px 4px 0px;
    font-family: Rubik;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    width: 532px;

`;



export const PhoneContainer = styled.div`
    display:flex;    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #3D3D3D;
    height: 42px;
    align-items:center;   
`

export const PhoneNumber = styled.div`
    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    width: 300px;
`

export const PhoneSource = styled.div`
    
    margin-left:${SIZE.THREE}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
`

export const PhoneSourceSubtitle = styled.div`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    text-align: left;
    color: #333;
    font-weight: bold;
    margin: 25px 0 ${SIZE.ONE}px 0;
`


export const PhoneSourceHolder = styled(ListItemContent)`
    ${SuggestLabel} {
        letter-spacing:normal;
    };    
    width: 300px;
`


export const AddressCustomContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: 300px;
`

export const AddressInput = styled.input`
  display: flex;
  box-sizing: border-box;
  border-radius: 5px;  
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: white;
        height: 30px;
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    text-align: left;           
`

export const AddressSelect = styled.select`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;           
`